import { Button, FeaturedIcon } from "@unified-checkout/design-system";
import { Circle, CircularPattern } from "./../../assets/Icons";
import type { IPageStatus } from "./../../types/page_status";
import styles from "./page-status.module.scss";

const featuredIconColor: any = {
  default: 'gray',
  warning: 'yellow',
  success: 'green',
  error: 'red'
};

export const PageStatus = (
  {
    status = 'default',
    title,
    description,
    icon = Circle,
    actionBtnsProps,
    keepIconDefaultColors = false,
    showBgCircles = true,
    iconSize = "xl"
  }
    :
    IPageStatus
) => {
  return (
    <div className={styles["page-status"]}>

      {
        <div className={styles["page-status__featured-icon"]}  data-page-status-icon-size={iconSize}>
          {showBgCircles && CircularPattern}
          <FeaturedIcon
            size={iconSize}
            color={featuredIconColor[status]}
            icon={icon}
            keepIconDefaultColors={keepIconDefaultColors}
          />
        </div>
      }

      <div className={styles["page-status__title"]}>
        {title}
      </div>

      {
        description &&
        <div className={styles["page-status__desc"]}>
          {description}
        </div>
      }

      {
        actionBtnsProps &&
        <div className={styles["page-status__action-btns"]}>
          {
            actionBtnsProps?.map((btn, i: number) =>
              <Button
                key={`page-status-action-btn-${i}`}
                size={btn.size}
                leadingIcon={btn.leadingIcon}
                trailingIcon={btn.trailingIcon}
                text={btn.text}
                color={btn.color}
                variant={btn.variant}
                disabled={btn.disabled}
                type={btn.type}
                onClickHandler={btn.onClickHandler}
                onBlurHandler={btn.onBlurHandler}
              />
            )
          }
        </div>
      }

    </div>
  )
};